import React from 'react';
import './RCard.css';

export default function RCard({ name, location, distance, rating, image }) {
  return (
    <div className="vcdp-rcard">
      <div className="vcdp-rcard-img">
        <img src={image} alt="Venue" />

      </div>
      <div className="vcdp-rcard-body">
        <div className='vcdp-rcard-header'>

          <div className='vcdp-rcard-title'>
            <h3 className="vcdp-title">{name.slice(0, 20)}{name.length > 20 && '...'}</h3>
          </div>

        </div>

        <div className='vcdp-rcard-footer'>
          <p className="vcdp-distance">{distance} Km</p>
          <div className="vcdp-rcard-rating">
            <span className="vcdp-star">★</span>
            <span className="vcdp-rating-value">{rating}</span>
          </div>
        </div>

        <p className="vcdp-location">
          {location.slice(0, 20)}{location.length > 20 && '...'}
        </p>
      </div>
    </div>
  );
}
